export const environment = {
  production: true,
  apiKey: "4ybLfJrX.49Gyx8adOpp0sFc6h7x0kLiLiZij9rQ0",
  apiUrl: "/api/",
  recaptcha: {
    siteKey: '6LdA1lgpAAAAAMJwjSQ1hja2zW8N8OL_Exa7LGm7',
  },
};
